import { useQuery } from '@tanstack/react-query'
import { fetchServiceConfig } from '../services/api'

/**
 * 서비스 설정 정보를 조회하는 훅
 * @returns {Object} 서비스 설정 정보와 로딩 상태
 */
export const useServiceConfig = () => {
	const {
		data: serviceConfig,
		isLoading,
		isError,
		error,
		refetch,
	} = useQuery({
		queryKey: ['serviceConfig'],
		queryFn: fetchServiceConfig,
		staleTime: 30 * 60 * 1000, // 30분간 캐시 유지 (거의 바뀔 일이 없는 설정)
		cacheTime: 60 * 60 * 1000, // 1시간간 메모리에 보관
		retry: 3, // 실패 시 3번 재시도
	})

	return {
		serviceConfig,
		isLoading,
		isError,
		error,
		refetch,
		// 편의를 위한 개별 값들
		mode: serviceConfig?.mode,
		year: serviceConfig?.year,
	}
}
